import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import styles from './index.styl';

const Label = ({ text, additionalClass, ...other }) => (
  <div
    {...other}
    styleName={classNames('root', {
      [`root--${additionalClass}`]: additionalClass,
    })}
  >
    <span>{text}</span>
  </div>
);

Label.propTypes = {
  text: PropTypes.string.isRequired,
  additionalClass: PropTypes.string,
};

Label.defaultProps = {
  additionalClass: '',
};

export default CSSModules(Label, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/Label/index.jsx